import SEK from './sek.svg?react';
import USD from './usd.svg?react';
import EUR from './eur.svg?react';
import NONE from './currency-none.svg?react';

export const CurrencyIcons = {
  SEK,
  USD,
  EUR,
  NONE,
};
